import { useLanguage } from '../context/LanguageContext';
import { translations } from '../helpers/language';

export const useFeedback = () => {
  const { language } = useLanguage();
  const t = translations[language].feedback;

  return {
    loading: t.loading,
    success: t.success,
    error: t.error,
    warning: t.warning,
  };
};
